import React, {useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../../api';


const TYPE_COLORS = {
  ASSET: 'bg-blue-100 text-blue-800', LIABILITY: 'bg-red-100 text-red-800',
  EQUITY: 'bg-purple-100 text-purple-800', REVENUE: 'bg-green-100 text-green-800', EXPENSE: 'bg-orange-100 text-orange-800',
};

export default function TrialBalance() {
  const [asOf, setAsOf] = useState(new Date().toISOString().split('T')[0]);
  const [report, setReport] = useState(null);

  const runReport = async () => {
    const params = asOf ? `?asOf=${asOf}` : '';
    const res = await api(`/reports/trial-balance${params}`);
    if (res.ok) setReport(await res.json());
  };

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow mb-6">
        <div className="p-4 md:p-6 border-b">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Trial Balance</h1>
          <div className="flex flex-col sm:flex-row gap-4 items-end">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">As Of Date</label>
              <input type="date" value={asOf} onChange={(e) => setAsOf(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-600" />
            </div>
            <button onClick={runReport} className="px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700">Run</button>
          </div>
        </div>
      </div>

      {report && (
        <div className="bg-white rounded-lg shadow">
          <div className="p-4 md:p-6 border-b">
            <h2 className="text-xl font-semibold text-gray-900">Trial Balance as of {report.asOf}</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Code</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Account</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Type</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Debit</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Credit</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {(report.lines || []).map((line, i) => (
                  <tr key={i}>
                    <td className="px-6 py-4 whitespace-nowrap font-mono text-gray-900">{line.accountCode}</td>
                    <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{line.accountName}</td>
                    <td className="px-6 py-4 whitespace-nowrap hidden md:table-cell">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${TYPE_COLORS[line.accountType] || 'bg-gray-100 text-gray-800'}`}>{line.accountType}</span>
                    </td>
                    <td className="px-6 py-4 text-right font-mono">{line.debit > 0 ? line.debit.toFixed(2) : ''}</td>
                    <td className="px-6 py-4 text-right font-mono">{line.credit > 0 ? line.credit.toFixed(2) : ''}</td>
                  </tr>
                ))}
                <tr className="bg-gray-50 font-semibold">
                  <td colSpan={3} className="px-6 py-3 text-right">Totals</td>
                  <td className="px-6 py-3 text-right font-mono">{(report.totalDebit || 0).toFixed(2)}</td>
                  <td className="px-6 py-3 text-right font-mono">{(report.totalCredit || 0).toFixed(2)}</td>
                </tr>
                {report.totalDebit !== report.totalCredit && (
                  <tr className="bg-red-50">
                    <td colSpan={3} className="px-6 py-3 text-right text-red-600 font-semibold">Difference</td>
                    <td colSpan={2} className="px-6 py-3 text-right font-mono text-red-600 font-semibold">{Math.abs((report.totalDebit || 0) - (report.totalCredit || 0)).toFixed(2)}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {(report.lines || []).length === 0 && <div className="text-center py-12 text-gray-500">No posted entries found.</div>}
        </div>
      )}
    </Layout>
  );
}
